import Button from "../../../../../common/components/atom/Button/Button";
import TextInput from "../../../../../common/components/atom/TextInput/TextInput";
import MessageCard from "../../../../../common/components/molecule/MessageCard/MessageCard";
import styles from "./AuthFormView.module.scss";

export interface AuthFormViewProps {
  email?: string;
  password?: string;
  setEmail?: (email: string) => void;
  setPassword?: (password: string) => void;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  organizationRender?: () => JSX.Element;
  linkToResetPassword?: string;
  onClickForgetPassword?: () => void;
}

/**
 * Auth form view
 * @param param0
 * @returns
 */
export default function AuthFormView({
  email,
  password,
  setEmail,
  setPassword,
  handleSubmit,
  messageError,
  isLoading,
  organizationRender,

  onClickForgetPassword,
}: AuthFormViewProps) {
  return (
    <div className={[styles["container"]].join(" ")}>
      {organizationRender && (
        <p className={[styles["container__header-title"]].join(" ")}>
          {organizationRender()}
        </p>
      )}
      <h1 className={[styles["container__title"]].join(" ")}>
        Heureux de vous revoir
      </h1>
      <p className={[styles["container__description"]].join(" ")}>
        Saisissez vos identifiant à associez à votre compte JouleWay
      </p>
      <div className={[styles["container__error-message"]].join(" ")}>
        <MessageCard variant="danger" message={messageError} width100 />
      </div>
      <form
        className={[styles["form"]].join(" ")}
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit && handleSubmit();
        }}
      >
        <div className={[styles["form__item"]].join(" ")}>
          <TextInput
            label="Email"
            value={email}
            onChange={(e) => {
              setEmail && setEmail(e.target.value);
            }}
          />
        </div>

        <div className={[styles["form__item"]].join(" ")}>
          <TextInput
            label="Password"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword && setPassword(e.target.value);
            }}
            withShowPasswordBtn
          />
        </div>

        <div className={[styles["form__button-container"]].join(" ")}>
          <div className={[styles["form__button-container__item"]].join(" ")}>
            <Button isLoading={isLoading} type={"submit"}>
              Se connecter
            </Button>
          </div>

          {onClickForgetPassword && (
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button onClick={onClickForgetPassword} variant="tertiary">
                Mot de passe oublié ?
              </Button>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}
